import React from "react";

const WeddingCarRental = () => {
  return (
    <>
      {/* ===== BREADCRUMB ===== */}
<section
        className="breadcrumb-section"
        style={{
          backgroundImage:
            "url(/images/background/inner-banner-bg.jpg)",
        }}
      >
        <div className="container">
          <div className="banner-content text-center">
            <h1>Wedding Car Rental</h1>
          </div>
        </div>
      </section>



      {/* ===== MAIN CONTENT SECTION ===== */}
      <section className="py-5 bg-white">
        <div className="container">
          <div className="row align-items-center">

            {/* IMAGE */}
            <div className="col-lg-6 mb-4 mb-lg-0">
              <img
                src="/images/gallery/08.jpeg"
                alt="Luxury Wedding Car Rental in Pune"
                className="img-fluid rounded shadow-lg"
              />
            </div>

            {/* CONTENT */}
            <div className="col-lg-6">
              <h2 className="mb-3">
                <span className="text-danger">Wedding</span> Car Rental Services
              </h2>

              <p>
                Pune Corporate Cars India Pvt. Ltd. offers premium and
                luxury wedding car rental services in Pune for couples
                who want elegance, comfort, and reliability on their
                special day. From grand bridal entry to seamless guest
                transportation, we ensure every journey is flawless.
              </p>

              <p>
                Our wedding fleet includes luxury sedans, premium SUVs,
                and chauffeur-driven cars that are ideal for bride & groom
                entry, family travel, and VIP guest movement. Each vehicle
                is immaculately maintained and can be decorated as per
                wedding themes and traditions.
              </p>

              <p>
                With professionally trained chauffeurs, punctual service,
                and dedicated coordination, we guarantee stress-free
                transportation across wedding venues, hotels, airports,
                and reception locations.
              </p>
            </div>

          </div>
        </div>
      </section>

      {/* ===== WHY CHOOSE US ===== */}
      <section className="py-5 bg-light">
        <div className="container">

          <div className="row mb-4">
            <div className="col-12 text-center">
              <h2 className="mb-3">Why Choose Us for Wedding Car Rental?</h2>
              <p className="text-muted">
                Trusted wedding transportation partner for luxury,
                destination, and large-scale weddings in Pune and
                across Maharashtra.
              </p>
            </div>
          </div>

          <div className="row">

            <div className="col-md-6 mb-4">
              <ul className="list-unstyled">
                <li className="mb-3">✔ Premium & luxury wedding car fleet</li>
                <li className="mb-3">✔ Decorated cars for bride & groom entry</li>
                <li className="mb-3">✔ Uniformed & professional chauffeurs</li>
                <li className="mb-3">✔ On-time arrival & route planning</li>
              </ul>
            </div>

            <div className="col-md-6 mb-4">
              <ul className="list-unstyled">
                <li className="mb-3">✔ Guest transportation & family movement</li>
                <li className="mb-3">✔ Airport pickup for wedding guests</li>
                <li className="mb-3">✔ Single-day & multi-day wedding packages</li>
                <li className="mb-3">✔ 24×7 coordination & support</li>
              </ul>
            </div>

          </div>

        </div>
      </section>
    </>
  );
};

export default WeddingCarRental;
